import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

export type SchedulingPhase =
  | 'idle'
  | 'accumulating_tickets'
  | 'tickets_accumulated'
  | 'fetching_available_fes'
  | 'planning_route'
  | 'route_planned'
  | 'writing_to_otrs'
  | 'completed'
  | 'outbound_pudo_scanning'
  | 'outbound_pudo_selecting_fe'
  | 'outbound_pudo_writing_actions'
  | 'outbound_pudo_done'
  | 'send_email_part_exchange_started'
  | 'send_email_part_exchange_done'
  | 'send_email_part_exchange_error'
  | 'error';

@Entity()
export class SchedulingState extends AdornisEntity {
  static override _class = 'SchedulingState';

  @Field(() => String) phase: Maybe<SchedulingPhase>;
  @Field(() => String) message: Maybe<string>;
  @Field(() => Int) ticketsViewedCount: Maybe<number>;
  @Field(() => Int) ticketsToScheduleCount: Maybe<number>;
  @Field(() => Int) ticketsWithFECount: Maybe<number>;
  @Field(() => Int) availableFECount: Maybe<number>;
  @Field(() => Int) routesCount: Maybe<number>;
  @Field(() => String) error: Maybe<string>;
  @Field(() => Date) updatedAt: Maybe<Date>;

  constructor(doc: PartialEntityData<SchedulingState>) {
    super(doc);
  }
}
